// Rótulos em pt-BR para papéis e status (usados nas telas de conta, equipe e convite).
import type { AccountRole, AccountStatus, CompanyRole } from '@impulso/shared'

export const ACCOUNT_ROLE_LABEL: Record<AccountRole, string> = { owner: 'Dono(a)', admin: 'Administrador(a)', member: 'Membro' }
export const ACCOUNT_ROLE_HELP: Record<AccountRole, string> = {
  owner: 'Pode tudo, inclusive plano e cobrança',
  admin: 'Gerencia empresas e usuários; acessa todas as empresas',
  member: 'Acessa só as empresas que receber',
}
export const COMPANY_ROLE_LABEL: Record<CompanyRole, string> = { manager: 'Gestor(a)', analyst: 'Analista', client: 'Cliente', viewer: 'Só leitura' }
export const COMPANY_ROLE_HELP: Record<CompanyRole, string> = {
  manager: 'Edita, aprova sugestões, publica e configura o piloto',
  analyst: 'Vê tudo e cria rascunhos; não publica nem mexe em orçamento',
  client: 'Portal do cliente: vê relatórios (e pode aprovar sugestões, se você permitir)',
  viewer: 'Só vê o painel e os relatórios',
}
export const ACCOUNT_STATUS_LABEL: Record<AccountStatus, { text: string; cls: string }> = {
  trial: { text: 'Teste grátis', cls: 'purple' },
  active: { text: 'Ativa', cls: 'green' },
  past_due: { text: 'Pagamento pendente', cls: 'amber' },
  readonly: { text: 'Somente leitura', cls: 'red' },
  suspended: { text: 'Suspensa', cls: 'red' },
  canceled: { text: 'Cancelada', cls: '' },
}

export const initials = (name: string) => name.split(' ').filter(Boolean).map((p) => p[0]).slice(0, 2).join('').toUpperCase() || '?'
export const dateBR = (iso: string | null | undefined) => (iso ? new Date(iso).toLocaleDateString('pt-BR') : '—')
